import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import ProporcionModal from "../../../ProporcionModal";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import * as XLSX from "xlsx";

import { v4 as uuidv4 } from "uuid";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function OrdenesCompraCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [moneda, setMoneda] = useState("");

  const [fecha, setFecha] = useState(hoy);
  const [plazo, setPlazo] = useState("");
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [folioProveedor, setFolioProveedor] = useState("");
  // Pedido de cliente al que se liga la OC (opcional). Al elegirlo se cargan
  // sus renglones y cada celda de la reja queda ligada al renglon del pedido
  // con el mismo modelo + color + talla.
  const [pedidos, setPedidos] = useState([]);
  const [selectedPedido, setSelectedPedido] = useState("");
  const [lineasPedido, setLineasPedido] = useState([]);
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  // renglonPedido: el renglon del pedido del que vino (el mismo modelo puede venir dos veces)
  const lineaPedidoDe = (idArt, idColor, idTalla, renglonPedido) =>
    lineasPedido.find((l) => String(l.articulos) === String(idArt) && String(l.colores) === String(idColor) && String(l.tallas) === String(idTalla)
      && (!renglonPedido || l.renglon === renglonPedido));

  async function eligePedido(idPedido) {
    setSelectedPedido(idPedido);
    setLineasPedido([]);
    if (!idPedido) return;
    try {
      const r = await axios.get(`${URL_ARTICULOS_PEDIDO}/pedidos/${idPedido}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      setLineasPedido((r.data || []).filter((a) => a.articulos?.[0]?._id).map((a) => ({
        _id: a._id,
        articulos: a.articulos?.[0]?._id,
        articulo: a.articulos[0],
        colores: a.colores?.[0]?._id || "",
        tallas: a.tallas?.[0]?._id || "",
        renglon: a.renglon || 1,
        cantidad: Number(a.cantidad) || 0,
        precio: Number(a.precio) || 0,
      })));
    } catch (err) {
      console.log(err);
    }
  }

  // Llena la reja con los modelos y cantidades del pedido elegido (un renglon
  // por modelo, celdas por color/talla con la cantidad pedida).
  function cargaDelPedido() {
    if (!lineasPedido.length) {
      Swal.fire({ icon: "info", title: "Sin renglones", text: "Ese pedido no tiene articulos." });
      return;
    }
    const resuelve = (lista, catalogo) => {
      if (!lista || !lista.length) return catalogo;
      return lista.map((x) => (x && x.name) ? x : catalogo.find((c) => String(c._id) === String(x && x._id ? x._id : x))).filter(Boolean);
    };
    const porArticulo = {};
    lineasPedido.forEach((l) => {
      const k = `${l.articulos}|${l.renglon}`;
      if (!porArticulo[k]) porArticulo[k] = { art: l.articulo, renglon: l.renglon, lineas: [] };
      porArticulo[k].lineas.push(l);
    });
    const nuevos = Object.values(porArticulo).sort((x, y) => x.renglon - y.renglon).map(({ art, renglon, lineas }) => {
      const cols = resuelve(art.colores, coloresCat);
      const tals = resuelve(art.tallas, tallasCat);
      // asegura que los colores/tallas del pedido esten en la reja aunque el modelo no los declare
      lineas.forEach((l) => {
        if (l.colores && !cols.some((c) => String(c._id) === String(l.colores))) { const c = coloresCat.find((x) => String(x._id) === String(l.colores)); if (c) cols.push(c); }
        if (l.tallas && !tals.some((t) => String(t._id) === String(l.tallas))) { const t = tallasCat.find((x) => String(x._id) === String(l.tallas)); if (t) tals.push(t); }
      });
      const tc = [];
      cols.forEach((c) => tals.forEach((t) => {
        const l = lineas.find((x) => String(x.colores) === String(c._id) && String(x.tallas) === String(t._id));
        tc.push({ colores: c._id, tallas: t._id, cantidad: l ? l.cantidad : 0 });
      }));
      const cantidad = tc.reduce((sum, c) => sum + (Number(c.cantidad) || 0), 0);
      const precio = Number(art.costoUSD) || 0;
      return {
        id: uuidv4(), colores: "", tallas: "", articulos: art._id, renglonPedido: renglon,
        articulosNombre: `${art.codigo} ${art.nombre}`, arrayColores: cols, arrayTallas: tals, tc,
        cantidad, precio, total: cantidad * precio,
      };
    });
    setInputFields(nuevos);
    ActualizaTotales(nuevos);
  }
  const [totalCaptura, setTotalCaptura] = useState(1);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      colores: "",
      tallas: "",
      articulos: "",
      articulosNombre: "",
      cantidad: 0,
      precio: 0,
      total: 0,
    },
  ]);
  const [coloresCat, setColoresCat] = useState([]);
  // Captura por proporcion, igual que en pedidos
  const [modalProp, setModalProp] = useState(false);
  const [propFieldId, setPropFieldId] = useState(null);
  const [propColor, setPropColor] = useState(null);
  const [tallasCat, setTallasCat] = useState([]);

  const [validaBoton, setValidaBoton] = useState(true);


  useEffect(() => {
    axios
      .get(process.env.REACT_APP_URL_COLORES, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setColoresCat(res.data.filter((a) => a.is_active === "Si")))
      .catch((err) => console.log(err));
    axios
      .get(process.env.REACT_APP_URL_TALLAS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setTallasCat(res.data.filter((a) => a.is_active === "Si")))
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    axios
      .get(URL_PEDIDOS, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((res) => setPedidos((res.data || []).filter((p) => p.is_active !== "No")))
      .catch((err) => console.log(err));
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
    .get(`${URL_PROVEEDORES}`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const pedidoElegido = pedidos.find((p) => String(p._id) === String(selectedPedido));

  const saveOrdenCompra = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();

    // Un renglon de OC por cada celda de la reja con cantidad.
    const validInputFields = [];
    inputFields.filter((f) => f.articulos).forEach((f, iRenglon) => {
      (f.tc || []).forEach((c) => {
        if (parseFloat(c.cantidad) > 0) {
          const lp = selectedPedido ? lineaPedidoDe(f.articulos, c.colores, c.tallas, f.renglonPedido) : null;
          validInputFields.push({
            renglon: iRenglon + 1,
            articulos: f.articulos, colores: c.colores, tallas: c.tallas,
            articulosPedido: lp ? lp._id : "",
            cantidad: parseFloat(c.cantidad), precio: f.precio,
            total: parseFloat(c.cantidad) * (parseFloat(f.precio) || 0),
          });
        }
      });
    });
    if (validInputFields.length === 0) {
      setValidaBoton(true);
      toggleProgreso();
      Swal.fire({ icon: "warning", title: "Sin cantidades", text: "Captura al menos una cantidad en la reja de color y talla." });
      return;
    }
    let totalArticulos = validInputFields.length;

    try {
      await axios
        .post(
          URL_ORDENES_COMPRA,
          {
            fecha,
            proveedores: selectedProveedor,
            plazo,
            fecha_compromiso,
            total_general,
            total_cantidad,
            observaciones,
            embarcado: 0,
            moneda,
            folioProveedor,
            ...(selectedPedido ? { pedidos: selectedPedido } : {}),
            ...(pedidoElegido && pedidoElegido.clientes?.[0]?._id ? { clientes: pedidoElegido.clientes?.[0]?._id } : {}),
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((data) => {
          validInputFields.map((a) => {
            axios
              .post(
                URL_ARTICULOS_OC,
                {
                  ordenesCompra: data.data._id,
                  renglon: a.renglon,
                  articulos: a.articulos,
                  colores: a.colores,
                  tallas: a.tallas,
                  ...(a.articulosPedido ? { articulosPedido: a.articulosPedido } : {}),
                  cantidad: parseFloat(a.cantidad),
                  embarcado: 0,
                  pendiente_embarcar: parseFloat(a.cantidad),
                  precio: parseFloat(a.precio),
                  total: parseFloat(a.total),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Orden de Compra",
                        detalle: `${selectedProveedor} ${total_general}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                });
                console.log(error);
                setValidaBoton(true);
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
      console.log(error);
    }
  };
  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        colores: "",
        tallas: "",
        articulos: ultimo.articulos,
        articulosNombre: ultimo.articulosNombre,
        cantidad: 0,
        precio: ultimo.precio,
        total: 0,
      },
    ]);
  };

  // Proporcion de un solo color: reparte el total entre las tallas de ese renglon.

  // Alta de color/talla desde el modal de proporcion: se suma al catalogo, a la
  // reja del renglon en turno y se abren sus celdas para que aplicaProporcion
  // las encuentre.
  function nuevoColorDesdeModal(c) {
    setColoresCat((prev) => (prev.some((x) => String(x._id) === String(c._id)) ? prev : [...prev, c]));
    setInputFields((prev) => prev.map((i) => {
      if (i.id !== propFieldId) return i;
      if ((i.arrayColores || []).some((x) => String(x._id) === String(c._id))) return i;
      const tallas = i.arrayTallas || [];
      const celdas = tallas.map((t) => ({ colores: c._id, tallas: t._id, cantidad: 0 }));
      return { ...i, arrayColores: [...(i.arrayColores || []), c], tc: [...(i.tc || []), ...celdas] };
    }));
  }

  function nuevaTallaDesdeModal(t) {
    setTallasCat((prev) => (prev.some((x) => String(x._id) === String(t._id)) ? prev : [...prev, t]));
    setInputFields((prev) => prev.map((i) => {
      if (i.id !== propFieldId) return i;
      if ((i.arrayTallas || []).some((x) => String(x._id) === String(t._id))) return i;
      const colores = i.arrayColores || [];
      const celdas = colores.map((c) => ({ colores: c._id, tallas: t._id, cantidad: 0 }));
      return { ...i, arrayTallas: [...(i.arrayTallas || []), t], tc: [...(i.tc || []), ...celdas] };
    }));
  }

  // Proporcion del modelo completo: total + proporcion de colores + de tallas,
  // como en el layout (antes era color por color).
  function abreProporcion(idFila) {
    setPropColor(null);
    setPropFieldId(idFila);
    setModalProp(true);
  }

  // Vacia el resultado del reparto en las celdas de la reja.
  function aplicaProporcion(lineas) {
    setInputFields((prev) => {
      const conCeldas = prev.map((i) => {
        if (i.id !== propFieldId) return i;
        const tc = i.tc.map((c) => {
          const l = lineas.find((x) => x.colores === c.colores && x.tallas === c.tallas);
          // el reparto es del modelo completo: lo que no salio en el reparto queda en 0
          return l ? { ...c, cantidad: l.cantidad } : (propColor ? c : { ...c, cantidad: 0 });
        });
        return { ...i, tc };
      });
      const fresca = recalculaRenglon(conCeldas, propFieldId);
      ActualizaTotales(fresca);
      return fresca;
    });
  }

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, selectedArticulo) {
    let articulosNombre = selectedArticulo.codigo + " " + selectedArticulo.nombre;
    let FOB 
    articulos.map((a) => {
      if (a._id == selectedArticulo._id) {

        let idArticulo = a._id;
        if(moneda == "USD"){
         FOB = a.costoUSD
        }else{
          FOB = a.costoCNY
         }
        handleChangeInputArticulo(id, idArticulo, FOB, articulosNombre, a.colores, a.tallas);
      }
    });
  }

  const handleChangeInputArticulo = (id, idArticulo, FOB, articulosNombre, coloresArt, tallasArt) => {
    // Reja de captura: un renglon por color, una celda por talla. Si el modelo
    // declara sus colores y tallas se acota a esos; si no, se usa el catalogo.
    // Si el articulo trae sus colores/tallas como ids sin poblar, se resuelven
    // contra el catalogo; si no trae ninguno, se usa el catalogo completo.
    const resuelve = (lista, catalogo) => {
      if (!lista || !lista.length) return catalogo;
      return lista.map((x) => (x && x.name) ? x : catalogo.find((c) => String(c._id) === String(x && x._id ? x._id : x))).filter(Boolean);
    };
    const cols = resuelve(coloresArt, coloresCat);
    const tals = resuelve(tallasArt, tallasCat);
    const tc = [];
    cols.forEach((c) => {
      tals.forEach((t) => {
        tc.push({ colores: c._id, tallas: t._id, cantidad: 0 });
      });
    });
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.total = 0;
        i.precio = FOB;
        i.cantidad = 0;
        i.articulosNombre = articulosNombre;
        i.arrayColores = cols;
        i.arrayTallas = tals;
        i.tc = tc;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales(newInputFields);
  };

  function recalculaRenglon(lista, id) {
    return lista.map((i) => {
      if (i.id !== id) return i;
      const suma = (i.tc || []).reduce((s, c) => s + (parseFloat(c.cantidad) || 0), 0);
      return { ...i, cantidad: suma, total: suma * (parseFloat(i.precio) || 0) };
    });
  }

  function cambiaCelda(idFila, idColor, idTalla, valor) {
    setInputFields((prev) => {
      const conCelda = prev.map((i) => i.id !== idFila ? i : {
        ...i,
        tc: i.tc.map((c) => (c.colores === idColor && c.tallas === idTalla
          ? { ...c, cantidad: valor === "" ? "" : parseFloat(valor) || 0 } : c)),
      });
      const fresca = recalculaRenglon(conCelda, idFila);
      ActualizaTotales(fresca);
      return fresca;
    });
  }

  // Recibe la lista fresca; si no, lee el estado (que va un cambio atras).
  function ActualizaTotales(lista) {
    const fuente = lista || inputFields;
    let cant = fuente.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let importes = fuente.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);
  }

  function jalaProveedor(e) {
    // Cambiar de proveedor cambia la moneda y por lo tanto el costo, asi que los
    // renglones se reinician. Los totales se recalculan sobre esa lista limpia:
    // si no, se quedaban con la suma del articulo anterior.
    const limpio = [
      {
        id: uuidv4(),
        colores: "",
        tallas: "",
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ];
    setInputFields(limpio);
    ActualizaTotales(limpio);
    setSelectedProveedor(e);
    proveedores.map((a) => {
      if (a._id == e) {
        return setMoneda(a.moneda);
      }
    });
  }

  const options = articulos.map((option) => {
    const junta = option.codigo + option.nombre;
    const firstLetter = option.codigo?.[0]?.toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });
  function importarArchivo(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let hojas = [];

    if (name === "file") {
      let reader = new FileReader();
      reader.readAsArrayBuffer(target.files[0]);
      reader.onloadend = (e) => {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });

        workbook.SheetNames.forEach(function (sheetName) {
          // Here is your object
          var XL_row_object = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          hojas.push({
            data: XL_row_object,
            sheetName,
          });
        });

        let A1 = hojas[0].data;

        // Crear un objeto que mapee los codigo de los artículos a sus objetos correspondientes
        const articulosMap = {};
        articulos.forEach((articulo) => {
          articulosMap[articulo.codigo] = articulo;
        });

        const articulosNoEncontrados = [];

        // Iterar sobre A1 una sola vez
        for (const a of A1) {
          const articulo = articulosMap[a.codigo];
          if (articulo) {
            console.log("Artículo encontrado:", articulo); // Depuración
            inputFields.push({
              id: uuidv4(),
              colores: "",
              tallas: "",
              articulos: articulo._id,
              articulosNombre: articulo.codigo + " " + articulo.nombre,
              cantidad: a.cantidad,
              precio: a.precio,
              total: a.precio * a.cantidad,
            });
          } else {
            // Si no se encuentra el artículo, agregarlo a la lista de no encontrados
              articulosNoEncontrados.push(a.codigo);
          }
        }

        // Verificar si se encontraron artículos que no estaban en el mapa
        if (articulosNoEncontrados.length > 0) {
          const mensaje = `Los siguientes codigos no se encontraron: ${articulosNoEncontrados.join(
            ", "
          )}`;
          Swal.fire({
            title: "Artículos no encontrados",
            text: mensaje,
            icon: "warning",
            button: "Entendido",
          });
        }

        ActualizaTotales();
      };
    }
  }

//       function importarArchivoMigracion(event){
//    const target = event.target;
//    const value = target.type === "checkbox" ? target.checked : target.value;
//    const name = target.name;
//    let hojas = [];
  
//    if (name === "file") {
 
//      let reader = new FileReader();
//        reader.readAsArrayBuffer(target.files[0]);
//        reader.onloadend = (e) => {
//          var data = new Uint8Array(e.target.result);
//          var workbook = XLSX.read(data, { type: "array" });
 
//          workbook.SheetNames.forEach(function (sheetName) {
//            // Here is your object
//            var XL_row_object = XLSX.utils.sheet_to_json(
//              workbook.Sheets[sheetName]
//            );
//            hojas.push({
//              data: XL_row_object,
//              sheetName,
//            });
//          });
 
//          let A1 = hojas[0].data
 
//          let TC = totalCaptura
//          A1.map((a)=>{
//             TC = TC + 1
//            setTotalCaptura(TC)
//          inputFields.push({
//            id: uuidv4(),
//            articulos: a.idArticulo,
//            articulosNombre: a.codigo,
//           cantidad: a.cantidad,
//           precio: a.costoUSD,
//           total: (a.costoUSD * a.cantidad).toFixed(2),
//           articulosNombre: a.descripcion
//          })
//          })
 
//          ActualizaTotales()
//        }
//    }
//  }
//  console.log("hola", inputFields)

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_compras ? (
        <div className="card container col-12">
          <h3 align="center">Nueva Orden de Compra</h3>
          <Form onSubmit={saveOrdenCompra}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Proveedor</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedProveedor}
                  required
                  onChange={(e) => {
                    jalaProveedor(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Proveedor</option>
                  {proveedores
                    .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                    .map((a) => {
                        return <option value={a._id}>{a.nombre_comercial} {a.moneda}</option>;
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label>Plazo</Label>
                <Input
                  type="text"
                  placeholder="Plazo"
                  value={plazo}
                  required
                  onChange={(e) => {
                    setPlazo(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Fecha Compromiso</Label>
                <Input
                  type="date"
                  placeholder="Fecha Compromiso"
                  value={fecha_compromiso}
                  required
                  onChange={(e) => {
                    setFechaCompromiso(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={3}>
              <Label>Folio Proveedor</Label>
                <Input
                  type="text"
                  placeholder="Folio Proveedor"
                  value={folioProveedor}
                  required
                  onChange={(e) => {
                    setFolioProveedor(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Pedido de cliente (opcional)</Label>
                <Input type="select" value={selectedPedido} onChange={(e) => eligePedido(e.target.value)}>
                  <option value="">Sin pedido</option>
                  {pedidos
                    .slice()
                    .sort((a, b) => (a.idPedido > b.idPedido ? -1 : 1))
                    .map((p) => (
                      <option key={p._id} value={p._id}>
                        {p.idPedido} · {p.clientes?.[0]?.nombre_comercial || ""} · {p.fecha}{p.tipo === "Prepedido" ? " (PREPEDIDO)" : ""}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={3} style={{ display: "flex", alignItems: "flex-end", gap: 6 }}>
                {selectedPedido ? (
                  <>
                    <Button size="sm" color="info" onClick={cargaDelPedido} title="Llena la reja con los modelos y cantidades del pedido">
                      Cargar articulos del pedido
                    </Button>
                    <small style={{ color: "#64748b" }}>{lineasPedido.length} renglon(es)</small>
                  </>
                ) : null}
              </Col>
            </Row>
            <Row>
             
              <Col md={10}>
                <h4 id="logoutBoton">
                  TOTALES {total_cantidad} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>
            <Row>

            <Col>
                    <Input
                      type="file"
                      name="file"
                      id="file"
                      onChange={(event) =>
                        importarArchivo(event)
                      }
                    />
                    </Col>
            </Row>

            {/* Tabla Articulos */}

            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Buscador</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              {moneda == "USD" ? (
                <Col md={1}>
                <Label className="mr-sm-2">Precio USD</Label>
              </Col>
              ): (
                <Col md={1}>
                <Label className="mr-sm-2">Precio CNY</Label>
              </Col>
              )}
              
              <Col md={2}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={2}>
                  <Autocomplete
                      size="small"
                      value={inputField.articulosNombre}
                      onChange={(event, selectedArticulo) => {
                        BuscaArticulo(inputField.id, selectedArticulo);
                      }}
                      options={options.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.junta}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>
                          {option.codigo} {option.nombre}
                        </React.Fragment>
                      )}
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="articulosNombre"
                      type="text"
                      placeholder="Articulo"
                      value={inputField.articulosNombre}
                      required
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="precio"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Precio"
                      value={inputField.precio}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="total"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Total"
                      value={inputField.total}
                      disabled
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>

                {/* Reja de captura: un renglon por color, una celda por talla */}
                {(inputField.arrayColores || []).length > 0 ? (
                  <div style={{ margin: "4px 0 14px 0", padding: "8px 10px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
                    <div style={{ display: "flex", gap: 6, alignItems: "flex-end", marginBottom: 4 }}>
                      <div style={{ width: 166 }}>
                        <Button size="sm" color="primary" style={{ padding: "2px 8px", fontSize: "0.72rem" }}
                          title="Repartir un total entre los colores y tallas del modelo con su proporcion (ej. 2-1-1 y 1-2-2-1)"
                          onClick={() => abreProporcion(inputField.id)}>
                          <i className="fas fa-percent" /> Proporción
                        </Button>
                      </div>
                      {(inputField.arrayTallas || []).map((t) => (
                        <div key={t._id} style={{ width: 62, textAlign: "center", fontSize: "0.68rem", fontWeight: 700, color: "#64748b" }}>
                          {t.name}
                        </div>
                      ))}
                      <div style={{ width: 70, textAlign: "center", fontSize: "0.68rem", fontWeight: 700, color: "#64748b" }}>TOTAL</div>
                    </div>

                    {(inputField.arrayColores || []).map((col) => {
                      const celdas = (inputField.tc || []).filter((c) => c.colores === col._id);
                      const sumaColor = celdas.reduce((s, c) => s + (parseFloat(c.cantidad) || 0), 0);
                      return (
                        <div key={col._id} style={{ display: "flex", gap: 6, alignItems: "center", marginBottom: 4 }}>
                          <div style={{ width: 110, fontSize: "0.78rem", fontWeight: 600 }}>
                            {col.name}
                          </div>
                          <div style={{ width: 50 }} />
                          {(inputField.arrayTallas || []).map((t) => {
                            const celda = celdas.find((c) => c.tallas === t._id);
                            return (
                              <div key={t._id} style={{ width: 62 }}>
                                <Input bsSize="sm" type="number" min="0" style={{ textAlign: "right", padding: "2px 4px" }}
                                  value={celda ? celda.cantidad : 0}
                                  onChange={(e) => cambiaCelda(inputField.id, col._id, t._id, e.target.value)} />
                              </div>
                            );
                          })}
                          <div style={{ width: 70, textAlign: "right", fontSize: "0.8rem", fontWeight: 700 }}>
                            {new Intl.NumberFormat("es-MX").format(sumaColor)}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : null}
              </div>
            ))}

            <ProporcionModal
              abierto={modalProp}
              cerrar={() => setModalProp(false)}
              coloresCat={(() => {
                const f = inputFields.find((x) => x.id === propFieldId);
                const cols = (f && f.arrayColores) || coloresCat;
                return propColor ? cols.filter((c) => c._id === propColor) : cols;
              })()}
              tallasCat={(() => {
                const f = inputFields.find((x) => x.id === propFieldId);
                return (f && f.arrayTallas) || tallasCat;
              })()}
              onAplicar={aplicaProporcion}
            onNuevoColor={nuevoColorDesdeModal}
            onNuevaTalla={nuevaTallaDesdeModal}
            catalogoColores={coloresCat}
            catalogoTallas={tallasCat}
              marcarTodos
              titulo="Proporcion del modelo por color y talla"
            />
            <Row>
            <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <h4 id="logoutBoton">
                  TOTALES {total_cantidad} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoOrdenesCompra"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default OrdenesCompraCreate;
